<template>
  <div>
    <v-row>
      <v-col>
        <v-toolbar flat dense>
          <v-toolbar-title>
            Leveranceaftale
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn :loading="creating" :disabled="!canCreateApproval" text small @click="createApproval">
            Opret aftale
            <v-icon right> mdi-send-outline </v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-textarea v-model="description" label="Beskrivelse" filled></v-textarea>
        <v-textarea v-model="description" label="Besked fra aftalestiller" filled></v-textarea>
        <v-textarea v-model="description" label="Kommentar til godkendelse" filled></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SpecificationApproval',
  props: ['loading'],
  data() {
    return {
      description: '',
      creating: false
    }
  },
  computed: {
    canCreateApproval() {
      // User can create a new approval when the spec is not locked and the latest approval has been rejected
      return !this.approvals?.length || (!this.locked && this.approvals[0]?.approved === false);
    }
  },
  methods: {
    createApproval: async function() {
      this.creating = true;

      try {
        const approvalTypes = await this.$api.get(`approval/types/specification`);
        const type = approvalTypes.data.find(type => type.text === 'Materialebestilling');

        const response = await this.$api.post(`approval/component/create/${this.spec.id}/${type.value}`);

        if (!response.data.success || typeof response.data.message !== 'string') throw 'Error creating approval';

        this.spec.approvalId = response.message;
        this.$notifier.showSuccess({ message: 'Materialebestilling oprettet' });
        this.$emit('approval:create');
      } catch (error) {
        this.$store.dispatch('logError', { level: 'critical', transaction: 'ApprovalCreate', error })
        this.$notifier.showError({ message: this.$t('errors.createApproval') });
      } finally {
        this.creating = false;
      }
    },
  }
}
</script>
